import { render, staticRenderFns } from "./credits-faq.vue?vue&type=template&id=7c619382&lang=pug&"
import script from "./credits-faq.vue?vue&type=script&lang=js&"
export * from "./credits-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports